import { isLocalStudyExperience } from './mode';
import { clearStudyDemoDrafts, studyDemoReturnTo } from './lifecycle';
/** Full-screen readers/editors cover the outer experience banner. Keep identity and exit visible. */
export function StudyDemoIdentityStrip({ className = '' }: { className?: string }) {
  if (!isLocalStudyExperience()) return null;
  return (
    <aside
      aria-label="Fictional demo identity"
      className={`relative z-[70] flex h-12 min-h-12 shrink-0 items-center justify-between gap-2 border-b border-hairline bg-wash-sunshine px-3 text-xs text-ink ${className}`}
    >
      <strong>Demo · Alex · fictional</strong>
      <a
        href={studyDemoReturnTo(window.location.search, window.location.origin)}
        onClick={() => clearStudyDemoDrafts()}
        className="inline-flex min-h-11 items-center font-bold underline"
      >
        Exit demo
      </a>
    </aside>
  );
}
